import { action } from 'satcheljs';
import type { CategoryOperation } from '../store/schema/CategoryDialogViewState';

/**
 * Sets the initial state of category dialog view state
 */
export interface SetInitialCategoryDialogViewStateActionMessage {
    operation: CategoryOperation;
    initialCategoryName: string | undefined;
    colorId: string | undefined;
    isFavorite: boolean | undefined;
    keyboardShortcut: number | undefined;
    categoryId: string | undefined;
}
const defaultExport: (
    operation: CategoryOperation,
    initialCategoryName?: string,
    colorId?: string,
    isFavorite?: boolean,
    keyboardShortcut?: number,
    categoryId?: string
) => SetInitialCategoryDialogViewStateActionMessage = action(
    'setInitialCategoryDialogViewState',
    (
        operation: CategoryOperation,
        initialCategoryName?: string,
        colorId?: string,
        isFavorite?: boolean,
        keyboardShortcut?: number,
        categoryId?: string
    ): SetInitialCategoryDialogViewStateActionMessage => ({
        operation,
        initialCategoryName,
        colorId,
        isFavorite,
        keyboardShortcut,
        categoryId,
    })
);
export default defaultExport;
